// extracted by mini-css-extract-plugin
export default {"title_val_row":"title_val_row___XF2VP","title_val_row_title":"title_val_row_title___op9bf","title_val_row_val":"title_val_row_val___WbAh8"};